import React from "react";
import { Chip } from "@mui/material";
import { RECOGIDA_ESTADO_LABELS, RECOGIDA_ESTADO_CHIP } from "../../constants";
import {
  BADGE_COLORS,
  BADGE_COLOR_BY_SEVERITY,
  getBadgeStyles,
} from "../../../../components/ui/badgeColors";

/**
 * Badge de estado reutilizable para recogidas (paleta corporativa unificada)
 */
export default function EstadoBadge({ estado }) {
  const key = (estado ?? "").toUpperCase();
  const label = RECOGIDA_ESTADO_LABELS[key] || estado || "-";
  const color =
    BADGE_COLOR_BY_SEVERITY[RECOGIDA_ESTADO_CHIP[key]] || BADGE_COLORS.GRAY;

  return <Chip label={label} size="small" sx={getBadgeStyles(color)} />;
}
